(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["curtain-catalog-browser"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('curtain-catalog-browser')) {
  customElements.define('curtain-catalog-browser', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const { signal } = this.controller;
      this.directory = this.querySelector('[data-directory]');
      this.header = this.querySelector('[data-directory-header]');
      this.panels = [...this.querySelectorAll('[data-family-panel]')];
      this.cards = [...this.querySelectorAll('[data-category-card]')];
      this.querySelector('[data-axis-controls]').hidden = false;
      this.addEventListener('click', event => {
        const axis = event.target.closest('[data-axis]');
        if (axis) this.filter(axis.dataset.axis);
        const measure = event.target.closest('[data-action="measure"]');
        if (measure) {
          const dialog = document.querySelector('curtain-review-stage [data-measure]');
          if (dialog) {
            this.measureReturn = measure;
            if (!dialog.open) dialog.showModal();
          }
        }
      }, { signal });
      const measureDialog = document.querySelector('curtain-review-stage [data-measure]');
      measureDialog?.addEventListener('close', () => { this.measureReturn?.focus(); this.measureReturn = null; }, { signal });
      window.addEventListener('hashchange', () => this.sync(true), { signal });
      this.sync(false);
    }
    filter(axis) {
      const groups = { function: ['light_control', 'function'], style: ['material', 'fabric_finish', 'heading', 'format_fit'], room: ['room'] };
      this.cards.forEach(card => { card.hidden = axis !== 'all' && !groups[axis]?.includes(card.dataset.familyAxis); });
      this.querySelectorAll('[data-axis]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.axis === axis)));
    }
    sync(moveFocus) {
      const previousHandle = this.currentHandle;
      const handle = location.hash.startsWith('#curtain-family-') ? location.hash.slice(16) : null;
      const panel = this.panels.find(item => item.dataset.familyPanel === handle);
      this.currentHandle = panel?.dataset.familyPanel || null;
      this.panels.forEach(item => { item.hidden = item !== panel; });
      this.directory.hidden = Boolean(panel);
      this.header.hidden = Boolean(panel);
      this.querySelectorAll('.ccf-shortcuts [data-family-link]').forEach(item => item.dataset.familyLink === handle ? item.setAttribute('aria-current', 'page') : item.removeAttribute('aria-current'));
      if (panel && moveFocus) {
        panel.querySelector('[data-family-heading]').focus({ preventScroll: true });
        this.scrollIntoView({ block: 'start' });
      }
      if (!panel && moveFocus && location.hash === '#curtain-catalog') {
        this.filter('all');
        const previousCard = this.cards.find(card => card.dataset.familyHandle === previousHandle);
        const focusTarget = previousCard?.querySelector('a') || this.header.querySelector('h2');
        focusTarget.focus({ preventScroll: true });
        this.scrollIntoView({ block: 'start' });
      }
    }
    disconnectedCallback() { this.controller?.abort(); this.controller = null; }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["curtain-catalog-collection"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('curtain-catalog-collection')) {
  customElements.define('curtain-catalog-collection', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const { signal } = this.controller;
      this.dialog = this.querySelector('[data-catalog-measure]');
      this.addEventListener('click', event => {
        const trigger = event.target.closest('[data-action="measure"]');
        if (trigger) { this.returnFocus = trigger; if (!this.dialog.open) this.dialog.showModal(); }
        if (event.target.closest('[data-catalog-close]')) this.dialog.close();
      }, { signal });
      this.dialog.addEventListener('close', () => { if (this.returnFocus?.getClientRects().length) this.returnFocus.focus(); }, { signal });
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const rect = this.dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
      }, { signal });
      const handle = location.pathname.split('/collections/')[1]?.split('/')[0];
      this.querySelectorAll('.ccf-shortcuts [data-family-link]').forEach(item => item.dataset.familyLink === handle ? item.setAttribute('aria-current', 'page') : item.removeAttribute('aria-current'));
    }
    disconnectedCallback() { this.controller?.abort(); this.controller = null; if (this.dialog?.open) this.dialog.close(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
